module.exports = __webpack_public_path__ + "static/media/sajin.026067d1.jpg";